<template>
  <div class="pt-8 pb-10 px-3" v-if="!loading && requests.length > 0">
    <v-slide-y-transition group>
      <RequestHistoryItem v-for="request in requests" :key="request.uuid" :item="request" />
    </v-slide-y-transition>
  </div>
  <v-layout
    v-else-if="!loading && requests.length === 0"
    justify-center
    fill-height
    align-center
    column
  >
    <v-btn outlined fab disabled>
      <v-icon size="40">mdi-exclamation</v-icon>
    </v-btn>
    <p class="pt-5 color--nice-grey">신청 내역이 존재하지 않습니다.</p>
  </v-layout>
</template>

<script>
import { defaultApi } from '@/plugins/api/defaultApi'
import { mapActions } from 'vuex'

export default {
  components: {
    RequestHistoryItem: () =>
      import('@/components/credit-pay/request/history/RequestHistoryItem.vue'),
  },
  data() {
    return {
      requests: [],
      loading: false,
    }
  },
  async created() {
    this.loading = true

    const {
      data: { data },
    } = await defaultApi.getCreditPaysRequests({ size: 1000 })

    this.requests = data || []
    this.loading = false
  },
  methods: {
    ...mapActions('creditPay/wholesaler', ['loadAllWholesalerAccounts']),
  },
}
</script>

<style lang="scss" scoped></style>
